module.exports = __webpack_public_path__ + "static/img/3.9f6131a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/3.png
// module id = P4dE
// module chunks = 0